import { useEffect, useRef } from "react";
import { T } from "../../../app/tokens.js";
import { btn } from "../weekly/weeklyUi.js";

// Non-modal: an outside pointer dismisses without consuming the intended
// cover/tab/pager click. Only Escape restores focus to the remove trigger.
export function MediaRemoveConfirmation({ item, trigger: invokingButton, onCancel, onConfirm }) {
  const host = useRef(null);
  const triggerRef = useRef(null);
  const cancel = useRef(onCancel); cancel.current = onCancel;
  useEffect(() => {
    const trigger = invokingButton ?? document.activeElement;
    triggerRef.current = trigger;
    host.current?.querySelector("[data-cancel]")?.focus();
    const pointer = event => { if (!host.current?.contains(event.target)) cancel.current(); };
    const key = event => {
      if (event.key !== "Escape") return;
      event.preventDefault(); event.stopImmediatePropagation();
      cancel.current();
      requestAnimationFrame(() => { if (trigger?.isConnected) trigger.focus({ preventScroll: true }); });
    };
    document.addEventListener("pointerdown", pointer, true);
    document.addEventListener("mousedown", pointer, true);
    document.addEventListener("click", pointer, true);
    // Match the gallery viewer's topmost boundary, ahead of document and
    // page-level sheet handlers (including shortcuts targeted at window).
    window.addEventListener("keydown", key, true);
    return () => {
      document.removeEventListener("pointerdown", pointer, true);
      document.removeEventListener("mousedown", pointer, true);
      document.removeEventListener("click", pointer, true);
      window.removeEventListener("keydown", key, true);
    };
  }, [invokingButton]);
  return <div ref={host} role="dialog" data-media-transient-confirmation aria-label={item.type === "pdf" ? "Remove this document?" : "Remove this photo?"}
    style={{ position: "sticky", bottom: 12, padding: 16, marginTop: 10, background: T.card, border: `1px solid ${T.border}`, borderRadius: 10, boxShadow: T.cardShadow, zIndex: 3 }}>
    <p>{item.type === "pdf" ? "This document" : "This photo"} will be removed from the gallery. You can undo for eight seconds.</p>
    <button type="button" style={btn} onClick={onConfirm}>Remove</button>{" "}
    <button data-cancel type="button" style={btn} onClick={() => {
      onCancel();
      const trigger = triggerRef.current;
      requestAnimationFrame(() => { if (trigger?.isConnected) trigger.focus({ preventScroll: true }); });
    }}>Cancel</button>
  </div>;
}
